import {
  MasonryWSDriverNodeRenderersRegistry,
  MasonryDriverNodeRenderersRegistry,
  MasonryDriverActionController,
  masonrySetTitleBaseActionHandler,
} from '@leagueplatform/masonry';
import { RewardProgramsCardNodeRenderer } from '@leagueplatform/health-journey';
import { MASONRY, MASONRY_V2 } from 'common/constants';
import { RichTextSection } from 'components/masonry-rich-text/masonry-rich-text.component';
import { PwpHeader } from 'components/pwp/pwp-header.component';
import { PwpPrintButton } from 'components/pwp/pwp-pdf-print-button.component';
import { PWPDisclaimerWidget } from 'pages/pwp/pwp-disclaimer-widget.component';
import { EasyPlanWidget } from 'components/easy-plan/easy-plan-widget-component';
import { HsaPendingBannerWidget } from 'components/hsa-pending-banner/hsa-pending-banner-widget.component';
import { RegionBannerHomeRenderer } from 'components/region-selection/region-selection-banner.renderer';
import { GenericStatusBanner } from 'components/status-banner-masonry-widget/generic-status-banner.component';
import { RewardProgramsCarousel } from 'components/carousel/RewardProgramsCarousel';
import { SectionHeaderRenderer } from 'components/masonry-section-header/section-header-renderer.component';
import { SectionHeader } from 'components/masonry-section-header/section-header-widget.component';
import { StatusBannerWithModal } from 'components/status-banner-with-modal/status-banner-with-modal.component';
import { masonryRedirectActionHandler } from 'utils/masonry-redirect-action-handler';
import { masonryGoBackActionHandler } from 'utils/masonry-go-back-action-handler';
import { MasonrySidebarButtonRenderer } from 'components/masonry-sidebar-button-renderer/masonry-sidebar-button-renderer';
import { CTACardRenderer } from 'components/masonry-cta-card-renderer.component';

export const initMasonryRegistry = () => {
  // Registering overviewText node type to Masonry WS Driver
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.NODE_TYPE_OVERVIEW_TEXT,
    RichTextSection,
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_HEADER,
    PwpHeader,
  );
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.NODE_TYPE_BUTTON_SECONDARY,
    PwpPrintButton,
  );

  // Registering disclaimer banner node type to Masonry WS Driver
  MasonryWSDriverNodeRenderersRegistry.registerRenderer(
    MASONRY.NAMESPACE_HIGHMARK,
    MASONRY.CUSTOM_WIDGET_TYPE_PWP_DISCLAIMER,
    PWPDisclaimerWidget,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REGION_BANNER,
    RegionBannerHomeRenderer,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_GENERIC_STATUS_BANNER,
    GenericStatusBanner,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_PENDING_HSA,
    HsaPendingBannerWidget,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_EASY_PLAN,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_EASY_PLAN,
    EasyPlanWidget,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAMS_CARD,
    RewardProgramsCardNodeRenderer,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_REWARD_PROGRAMS_CAROUSEL,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_REWARD_PROGRAMS_CAROUSEL,
    RewardProgramsCarousel,
  );

  // Override the section header renderer and widget to enable heading ids
  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    'sectionHeader',
    SectionHeaderRenderer,
  );

  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    MASONRY_V2.NAMESPACE_BENEFITS,
    'sectionHeader',
    SectionHeaderRenderer,
  );

  MasonryWSDriverNodeRenderersRegistry.overrideRenderer(
    MASONRY.DEFAULT_NAMESPACE,
    'section_header',
    SectionHeader,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_SIDEBAR_BUTTON,
    MasonrySidebarButtonRenderer,
  );

  MasonryDriverNodeRenderersRegistry.overrideRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.WIDGET_TYPE_CTA_CARD,
    CTACardRenderer,
  );

  MasonryDriverNodeRenderersRegistry.registerRenderer(
    MASONRY_V2.NAMESPACE_DEFAULT,
    MASONRY_V2.CUSTOM_WIDGET_TYPE_STATUS_BANNER_WITH_MODAL,
    StatusBannerWithModal,
  );

  MasonryDriverActionController.registerUniversalHandler(
    'setTitle',
    masonrySetTitleBaseActionHandler,
  );

  MasonryDriverActionController.registerHandler(
    'deeplink',
    MASONRY_V2.NAMESPACE_CUSTOM_WIDGET,
    masonryRedirectActionHandler,
  );

  MasonryDriverActionController.overrideHandler(
    'deeplink',
    MASONRY_V2.NAMESPACE_CUSTOM_ACTION,
    masonryGoBackActionHandler,
  );
};
